import { render, staticRenderFns } from "./addSmallProgram.vue?vue&type=template&id=93dab46c&scoped=true&"
import script from "./addSmallProgram.vue?vue&type=script&lang=ts&"
export * from "./addSmallProgram.vue?vue&type=script&lang=ts&"
import style0 from "./addSmallProgram.vue?vue&type=style&index=0&id=93dab46c&lang=scss&scoped=true&"
import style1 from "./addSmallProgram.vue?vue&type=style&index=1&id=93dab46c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93dab46c",
  null
  
)

export default component.exports